export default __webpack_public_path__ + "static/media/EDRulebook.ccf24989.pdf";